import { Col, Container, Row, Card, Badge, Image } from 'react-bootstrap';
import { motion } from "motion/react";
import servicesData from "../../data/servicesData.json";

const Features = () => {
    const getImage = (imageName) => {
        return require(`../../assets/${imageName}`)
    }

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.15 }
        }
    }

    const cardVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.5, ease: "easeOut" }
        }
    }

    return (
        <section className="section-lg overflow-hidden" id="services">
            <Container>
                <Row>
                    <Col xs={12} className='mb-5'>
                        <motion.h6 initial={{ opacity: 0, y: -30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 1, ease: 'linear', delay: 0.1 }} className="underline-after position-relative text-center z-0">
                            <span className="position-relative z-1 bg-white text-primary px-3">Why Growth Strategy?</span>
                        </motion.h6>
                        <motion.h1 initial={{ opacity: 0, scale: 0 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 1, ease: 'linear', delay: 0.1 }} className="d-block text-gradiant text-center fw-semibold">Focus on the levers that actually move the needle</motion.h1>
                    </Col>
                </Row>
                <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }}>
                    <Row>
                        {servicesData.features.map((feature) => (
                            <Col lg={4} md={6} xs={12} className="mb-4" key={feature.id}>
                                <motion.div variants={cardVariants} whileHover={{ y: -8, transition: { duration: 0.3 } }}>
                                    <Card className="feature-card h-100">
                                        <Card.Body className="p-4">
                                            <div className="d-flex align-items-center mb-3">
                                                <span className={`icon-badge rounded-circle bg-${feature.iconBg}-subtle text-${feature.iconBg} d-inline-flex align-items-center justify-content-center me-2`} style={{ width: '44px', height: '44px' }}>
                                                    <i className={`${feature.icon} fs-5`}></i>
                                                </span>
                                                <h5 className="mb-0">{feature.title}</h5>
                                            </div>
                                            <p className="text-secondary mb-0">{feature.description}</p>
                                        </Card.Body>
                                    </Card>
                                </motion.div>
                            </Col>
                        ))}
                    </Row>
                </motion.div>
                <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }}>
                    <Row className="mt-2">
                        {servicesData.detailedFeatures.map((feature, index) => (
                            <Col lg={6} xs={12} className="mb-4" key={feature.id}>
                                <motion.div variants={cardVariants} whileHover={{ scale: 1.02, transition: { duration: 0.3 } }}>
                                    <Card className="feature-card h-100 shadow-sm overflow-hidden">
                                        <Row className="g-0">
                                            <Col sm={5} className={feature.imagePosition === 'right' ? 'order-sm-2' : ''}>
                                                <Image src={getImage(feature.image)} alt={feature.title} className="w-100 h-100 object-fit-cover img-zoom" />
                                            </Col>
                                            <Col sm={7} className={feature.imagePosition === 'right' ? 'order-sm-1' : ''}>
                                                <Card.Body>
                                                    <h5 className="mb-2 d-flex align-items-center">
                                                        <i className={`${feature.icon} text-${feature.iconColor} fs-4 me-2`}></i>
                                                        {feature.title} <Badge bg={`${feature.badgeVariant}-subtle`} text={feature.badgeVariant} className={`border border-${feature.badgeVariant}-subtle ms-2`}>{feature.badge}</Badge>
                                                    </h5>
                                                    <p className="text-secondary mb-3">{feature.description}</p>
                                                    <ul className="list-unstyled lh-lg mb-0">
                                                        {feature.items.map((item, idx) => (
                                                            <li key={idx} className="item-list text-primary"><i className="ri-checkbox-circle-fill"></i> {item}</li>
                                                        ))}
                                                    </ul>
                                                </Card.Body>
                                            </Col>
                                        </Row>
                                    </Card>
                                </motion.div>
                            </Col>
                        ))}
                    </Row>
                </motion.div>
            </Container>
        </section>
    )
}

export default Features;
